import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { finalize } from 'rxjs/operators';
import { TenantService } from 'src/app/core/services/tenant.service';

@Component({
  selector: 'app-tenant-preview-modal',
  templateUrl: './tenant-preview-modal.component.html',
  standalone: false,
})
export class TenantPreviewModalComponent implements OnInit {
  primaryColor: string = '#ffffff';
  logoSrc: string = '';
  loading = false;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private tenantService: TenantService,
  ) {}

  ngOnInit(): void {
    if (this.config.data) {
      this.primaryColor = this.config.data.primaryColor || '#4073b0';

      if (this.config.data.tenantId) {
        this.loadTenantLogo(this.config.data.tenantId);
      } else {
        this.setLogoSource(this.config.data.logo);
      }
    }
  }

  private loadTenantLogo(tenantId: string): void {
    this.loading = true;
    this.tenantService
      .getTenant(tenantId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (tenant: any) => {
          this.setLogoSource(tenant?.logo);
        },
        error: () => {
          this.setLogoSource(null);
        },
      });
  }

  private setLogoSource(rawLogo: string | null | undefined): void {
    if (rawLogo) {
      if (
        !rawLogo.startsWith('http') &&
        !rawLogo.startsWith('assets') &&
        !rawLogo.startsWith('data:image')
      ) {
        this.logoSrc = 'data:image/png;base64,' + rawLogo;
      } else {
        this.logoSrc = rawLogo;
      }
      return;
    }

    this.logoSrc = 'assets/img/connect-sea/connect-sea-logo-branco.png';
  }

  close() {
    this.ref.close();
  }
}
